import React, {Component} from 'react';
import ParkingSlotTable from './../components/ParkingSlotTable';
import ObjectUtils from '../../../baseApp/shared/utils/ObjectUtils';
import {connect} from "react-redux";

class ParkingSlotTableContainer extends Component {

    constructor(props){
        super(props);
        this.state = {
            universalSearchField: "",
            searchFieldsValues: {
                parkingFloor: {
                    value: ""
                },
                slot: {
                    value: ""
                },
                category: {
                    value: ""
                },
                status: {
                    value: ""
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.changeCategoryModal.loadingRequest && !nextProps.changeCategoryModal.loadingRequest) {
            this.handleSearchSubmit();
        }
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        const {
            searchFieldsValues,
        } = this.state;

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                {...acc} : {...acc, [keyValuePair[0]]: keyValuePair[1].value}
        }, {});

        this.props.handleFetchData({
            ...filter,
            currentPage,
            pageSize,
            sortProperty,
            sortDirection
        })
    }

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }, 
                searchFieldsData: {
                    ...this.state.searchFieldsData
                }
            }
        })
    };

    handleSearchSubmit = () => {
        const {
            tableProps: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }
    
    onPageChange = (currentPage) => {
        const {
            tableProps: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    onPageSizeChange = (currentPage, itemsPerPage) => {
        const {
            tableProps: {
                sort,
                totalPages: pages 
            }
        } = this.props;

        if (currentPage > pages || currentPage < 1) return;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    }

    handleSortChanged = newSort => {
        const {
            tableProps:  {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    }

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    }

    render() {
        const {searchFieldsValues} = this.state;
        const {
            tableProps: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },

            searchFieldsData,
            handleSearchFieldValueChanged,
            handleParkingTableSlotClicked
        } = this.props;

        return (
            <ParkingSlotTable
                data={data}

                sort={sort}
                totalElements={totalElements}
                pages={pages}
                currentPage={currentPage}
                pageSize={pageSize}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}

                onRowClick={this.handleRowClicked}

                searchFieldsValues={searchFieldsValues}
                searchFieldsData={searchFieldsData}

                handleSearchFieldChange={this.handleSearchFieldChange}
                
                handleSortChanged={this.handleSortChanged}
                handleSearchClear={this.handleSearchClear}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchFieldValueChanged={handleSearchFieldValueChanged}

                handleParkingTableSlotClicked={handleParkingTableSlotClicked}
            />
        );
    }
}

const mapStateToProps = ({ parkingReducer }) => {
    return {
        changeCategoryModal: parkingReducer.selectedParking.changeCategoryModal
    };
};

export default connect(
    mapStateToProps,
    undefined
)(ParkingSlotTableContainer);